{
  "post-office.cc-changeboarding-block-menu-primary.spotlight-button": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "post-office.cc-changeboarding-block-menu-primary.spotlight-description": [
    {
      "type": 0,
      "value": "Blocks of content can now be easily transformed, kept in sync, and saved as a template!"
    }
  ],
  "post-office.cc-changeboarding-block-menu-primary.spotlight-header": [
    {
      "type": 0,
      "value": "Transform, sync & save blocks"
    }
  ],
  "post-office.cc-changeboarding-block-menu-primary.spotlight-image-alt": [
    {
      "type": 0,
      "value": "Blocks feature illustration"
    }
  ],
  "post-office.cc-changeboarding-block-menu-transform.spotlight-button": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "post-office.cc-changeboarding-block-menu-transform.spotlight-description": [
    {
      "type": 0,
      "value": "Easily change content blocks from one format to another!"
    }
  ],
  "post-office.cc-changeboarding-block-menu-transform.spotlight-header": [
    {
      "type": 0,
      "value": "Transform blocks with 'Turn into'"
    }
  ],
  "post-office.cc-changeboarding-block-menu-transform.spotlight-image-alt": [
    {
      "type": 0,
      "value": "Turn into feature illustration"
    }
  ],
  "post-office.cc-changeboarding-block-menu-transform.spotlight-learn-more": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ]
}